import { render, staticRenderFns } from "./PanelsPage.vue?vue&type=template&id=b0daf01c"
import script from "./PanelsPage.vue?vue&type=script&lang=ts"
export * from "./PanelsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports